<template>
  <div
    id="engagementDetails"
    class="mainCard"
  >
    <el-page-header
      title="Go Back"
      :content="null"
      @back="$router.push({name: 'leaderEngagementsList'})"
    />

    <div v-if="engagement">
      <EngagementSummary
        :engagement="engagement"
        :display-details="true"
      />

      <el-row
        :gutter="5"
        type="flex"
        style="margin-top: 15px;"
      >
        <el-col :span="12">
          <ActionPlan
            :engagement-uuid="engagement.uuid"
            :action-plan="actionPlan"
          />
        </el-col>
        <el-col :span="12">
          <Pulse
            :engagement-uuid="engagement.uuid"
            :pulse="pulse"
          />
        </el-col>
      </el-row>

      <el-row
        :gutter="5"
        type="flex"
        style="margin-top: 15px;"
      >
        <el-col :span="12">
          <FeedForwards
            :load-feedforwards="false"
            :feedforwards-data="feedforwards"
            :from-past="true"
          />
        </el-col>
        <el-col :span="12">
          <SessionDetails
            :load-tasks="false"
            :tasks-data="tasks"
            :session-data.sync="selectedSession"
            :engagement="engagement"
          />
        </el-col>
      </el-row>

      <el-row
        :gutter="5"
        type="flex"
        style="margin-top: 15px;"
      >
        <el-col :span="12">
          <CvcReview :engagement="engagement.uuid" />
        </el-col>
        <el-col :span="12">
          <GLA
            v-loading="loading"
            :leader="engagement.leader_info"
          />
        </el-col>
      </el-row>

      <CoworkersTable
        :coworkers="coworkers"
        style="margin-top: 15px;"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api';
import CoworkersTable from '@/views/dashboard/content/coach/leaders/widgets/CoworkersTable.vue';
import EngagementSummary from './components/EngagementSummary.vue';
import ActionPlan from './components/ActionPlan.vue';
import Pulse from './components/Pulse.vue';
import FeedForwards from '../leaders/widgets/FeedForwards.vue';
import SessionDetails from '../leaders/widgets/SessionDetails.vue';
import CvcReview from '../leaders/widgets/CvcReview.vue';
import GLA from '../leaders/widgets/GLA.vue';

export default {
  name: 'EngagementDetails',

  components: {
    EngagementSummary,
    ActionPlan,
    Pulse,
    CoworkersTable,
    FeedForwards,
    SessionDetails,
    CvcReview,
    GLA,
  },

  data: () => ({
    loading: false,
    engagement: null,
    actionPlan: null,
    pulse: null,
    coworkers: [],
    feedforwards: null,
    tasks: null,
    selectedSession: null,
  }),

  watch: {
    selectedSession() {
      this.getEngagementTasks();
    },
  },

  async created() {
    await this.getEngagement();
    this.getEngagementCoworker();
    this.getEngagementPulseReport();
    this.getEngagementActionPlan();
    this.getEngagementFeedforward();
    this.getEngagementTasks();
  },

  methods: {
    async getEngagement() {
      try {
        this.loading = true;
        const response = await api.getEngagement(this.$route.params.id);
        this.engagement = response.data;
        this.selectedSession = response.data.duration;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementCoworker() {
      try {
        this.loading = true;
        const response = await api.getEngagementCoworker(this.$route.params.id);
        this.coworkers = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementPulseReport() {
      try {
        this.loading = true;
        const response = await api.getEngagementPulseReport(this.$route.params.id, { quick: true });
        this.pulse = response.data;
      } catch (err) {
        if (err.msg && err.msg !== 'Pulse Not found') {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementActionPlan() {
      try {
        this.loading = true;
        const response = await api.getEngagementActionPlan(this.$route.params.id);
        this.actionPlan = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementFeedforward() {
      try {
        this.loading = true;
        const response = await api.getEngagementFeedforward(this.$route.params.id);
        this.feedforwards = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementTasks() {
      try {
        this.loading = true;
        const response = await api.getEngagementTasks(this.$route.params.id, {
          session_id: `session_${this.selectedSession}`,
        });
        [this.tasks] = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#engagementDetails {
  .el-card.sessionDetails {
    height: 100%;
  }
}
</style>
